import React from 'react';
import { TextLarge } from '../../../components/text';
import { CardTheme } from '../../../components/card';
import { Col, Row, Spin } from 'antd';
import {
  FORM_CLAIM_CUSTOMER_EDIT_DATA,
  FORM_CLAIM_EDIT_DATA,
  FORM_CLAIM_EDIT_PICTURE,
} from './form';
import { ContainerButton } from '../../../styles/global-style';
import { useGetClaimEditList } from './hooks/useGetClaimEditList';
import { RenderForm } from '../../../components/forms';
import { ButtonTheme } from '../../../components/buttons';
import { StyledContainer } from '../../../components/container/styles';
import { TimelineComponent } from '../../../components/timeline';

export const ClaimEdit = () => {
  const {
    control,
    setValue,
    getValues,
    timelineList,
    provinceOptions,
    districtOptions,
    subDistrictOptions,
    breakdownSubsOptions,
    isLoadingClaimEdit,
    onEnterZipcode,
    breakdownList,
    isLoadingZipCode,
    onSubmit,
    isLoadingToEdit,
    isLoadingBreakdownSubs,
    onChangeBreakdown,
  } = useGetClaimEditList();

  return (
    <Spin
      spinning={isLoadingClaimEdit || isLoadingZipCode || isLoadingToEdit || isLoadingBreakdownSubs}
    >
      <StyledContainer>
        <TextLarge text="รายละเอียดรายการเคลมสินค้า" />
        <Row gutter={[24, 24]}>
          <Col span={10}>
            <CardTheme>
              <TextLarge text="ข้อมูลส่วนตัว" />
              <RenderForm
                control={control}
                getValues={getValues}
                setValue={setValue}
                forms={FORM_CLAIM_CUSTOMER_EDIT_DATA({
                  provinceOptions,
                  districtOptions,
                  subDistrictOptions,
                  onEnter: onEnterZipcode,
                })}
              />
            </CardTheme>
          </Col>
          <Col span={10}>
            <CardTheme>
              <TextLarge text="ข้อมูลการแจ้งเคลม" />
              <RenderForm
                control={control}
                getValues={getValues}
                setValue={setValue}
                onChange={onChangeBreakdown}
                forms={FORM_CLAIM_EDIT_DATA({ breakdownList, breakdownSubsOptions })}
              />
            </CardTheme>
          </Col>
          <Col span={4}>
            <TextLarge text="สถานะการเคลม" /> <br />
            <TimelineComponent timelineList={timelineList} />
          </Col>
        </Row>
        <br />
        <Row gutter={[24, 24]}>
          <Col span={10}>
            <CardTheme>
              <RenderForm
                control={control}
                getValues={getValues}
                setValue={setValue}
                forms={FORM_CLAIM_EDIT_PICTURE()}
              />
            </CardTheme>
          </Col>
        </Row>
        <ContainerButton center>
          <ButtonTheme useFor="SUBMIT" title="บันทึก" onClick={onSubmit} />
        </ContainerButton>
      </StyledContainer>
    </Spin>
  );
};
